// import { SpinnerProps } from './Spinner.interfaces';

export const Spinner = () => (
  <div className="c-spinner__icon" aria-hidden>
    <p className="h-hide-visually">Content is loading</p>
  </div>
);
